<template>
  <div id="app" class="app">
    <div class="inner">
      <main class="main">
        <router-view/>
      </main>
      <footer class="footer hide" :class="{'show': $route.path === '/'}">
        <router-link to="privacy" class="footer-link">Privacy</router-link>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    window.addEventListener('load', this.addDarkClass)
  },
  methods: {
    addDarkClass () {
      if (this.$route.query.mode === 'dark') {
        document.body.classList.add('dark')
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
}
.dark {
  background-color: black;
}
section {
  margin-bottom: 4rem;
}
a {
  color: #007AFF;
}
.dark a {
  color: #0984FF;
}
p,
ul {
  color: gray;
}
img {
  vertical-align: top;
}
h1 {
  font-size: 1.6rem;
  margin: 0;
  padding: 0;
}
h2 {
  font-size: 1.2rem;
  margin: 0;
  padding: 0;
}
.dark p,
.dark ul,
.dark h1,
.dark h2 {
  color: white;
}
.app {
  font-family: -apple-system,BlinkMacSystemFont,"Helvetica Neue","Hiragino Kaku Gothic ProN",メイリオ,Meiryo,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: 'palt' 1;
  line-height: 2;
  letter-spacing: 0.02em;
  font-size: 16px;
}
.inner {
  max-width: 640px;
  margin: 0 auto;
  padding: 16px 16px;
}
.header {
  text-align: center;
}
.logo {
  width: 160px;
  height: 160px;
}
.footer {
  position: fixed;
  bottom: 12px;
  right: 12px;
}
.footer-link {
  color: gray;
  font-weight: bold;
  text-decoration: none;
  font-size: 0.8rem;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, .1), 0 0 0 0.5px rgba(0, 0, 0, .04);
  padding: 4px 8px 4px 8px;
  z-index: 100;
}
.dark .footer-link {
  background-color: #1c1c1e;
  color: gray;
}
.hide {
  display: none;
}
.show {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue